<template>
  <div>
    <label :for="inputId">
      <div class="avatar-md align-self-center me-3" :class="customClass">
        <div class="avatar-title fs-16 rounded bg-white border-dashed border text-muted text-opacity-50 cursor-pointer">
          <span style="font-size: 3rem;" class="text-body text-opacity-25">+</span>
        </div>
      </div>
    </label>
    <input :id="inputId" type="file" style="display: none" @change="onFileSelected" :multiple="multiple">
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    inputId: {
      type: String,
      default: 'fileInput'
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      selectedFile: []
    }
  },
  methods: {
    onFileSelected (event) {
      this.selectedFile = this.multiple ? Array.from(event.target.files) : [event.target.files[0]];
      this.$emit('onFileSelected', _.cloneDeep(this.selectedFile))
    },
  },
};
</script>
